// extracted by mini-css-extract-plugin
module.exports = {"Header":"styles_Header__3ivrJ","IsOpen":"styles_IsOpen__3HWjv","IsNotOpen":"styles_IsNotOpen__3QaAB"};